export const environment = {
  production: true,
  serverUrl: 'https://diapanel.optimistkitap.com',
};
